export default __webpack_public_path__ + "static/media/angelotwo5.cb07ce84.jpg";